export default __webpack_public_path__ + "static/media/modulePregnancyEs.8c263b0a.mp4";